// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-statistics-payment-modal__container {
    padding: 18px 36px;
}

.profile-statistics-payment-modal__container-text.baloa-table {
    color: var(--primary-dark-color);
    margin-bottom: 12px;
}

.profile-statistics-payment-modal__container-table {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
}

.profile-statistics-payment-modal__container-table__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 24px;
    background: var(--new-background-color);
    border-radius: 7px;
    margin-bottom: 10px;
}

.profile-statistics-payment-modal__container-table__header-col__tournament,
.profile-statistics-payment-modal__container-table__body-tournament__col.data {
    width: 50%;
}

.profile-statistics-payment-modal__container-table__header-col__value,
.profile-statistics-payment-modal__container-table__body-tournament__col.value {
    width: 25%;
}

.profile-statistics-payment-modal__container-table__body-tournament__col.value .baloa-names {
    color: var(--primary-very-dark-color);
    white-space: nowrap;
}

.profile-statistics-payment-modal__container-table__header-col__blank,
.profile-statistics-payment-modal__container-table__body-tournament__col.action {
    width: 25%;
}

.profile-statistics-payment-modal__container-table__body-tournament__col.action {
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-statistics-payment-modal__container-table__header .baloa-table-column {
    color: var(--basic-gray-color);
}

.profile-statistics-payment-modal__container-table__body-tournament__container {
    padding: 12px 24px;
    border-bottom: 1px solid var(--new-gray-background-color);
    display: flex;
    align-items: center;
}

.profile-statistics-payment-modal__container-table__body-tournament__container:last-of-type {
    border-bottom: none;
}

.profile-statistics-payment-modal__container-table__body-tournament__col.data {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.profile-statistics-payment-modal__container-table__body-tournament__col-info__img img {
    width: 39px;
    height: 39px;
    border-radius: 50%;
}

.profile-statistics-payment-modal__container-table__body-tournament__col-info__img .icon-ball {
    color: var( --white-color );
    font-size: 39px;
    border-radius: 50%;
    padding: 4px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament {
    margin-left: 8px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament .baloa-names {
    color: var(-primary-very-dark-color);
    margin-bottom: 4px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament-labels {
    display: flex;
    align-items: center;
    gap: 4px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament-labels .baloa-mini {
    color: var(--primary-dark-color);
    padding: 3px 6px;
    background: var(--new-grey-light-background-color);
    border: 1px solid var(--new-grey-border-color);
    border-radius: 25px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__col.action .primary-button {
    padding: 8px 20px;
    font-size: 14px;
    line-height: 16px;
 }

 .profile-statistics-payment-modal__unlock-all-action {
    border-top: 1px solid var(--new-input-background-color);
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
 }

 .profile-statistics-payment-modal__unlock-all-action .primary-button,
 .profile-statistics-payment-modal__container-table__body-tournament__mobile-amount .primary-button {
    font-size: 16px;
    line-height: 19px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__mobile-amount {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
 }

 .profile-statistics-payment-modal__container-table__body-tournament__mobile-container {
    padding: 16px 0;
    border-bottom: 1px solid var(--new-gray-background-color);
 }

 .profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar {
    display: none; 
}

.profile-statistics-payment-modal__container-table__body .infinite-scroll-component:hover::-webkit-scrollbar {
    display: initial;
}

.profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar:vertical {
    width:10px;
}

.profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar:horizontal {
    height: 10px;
}

.profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

 @media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .profile-statistics-payment-modal .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: 100%;
        height: 100%;
    }  
    
    .profile-statistics-payment-modal .modal2__content {
        height: 100%;
    }

    .profile-statistics-payment-modal__container {
        padding: 12px;
    }

    .profile-statistics-payment-modal__container-table {
        border: none
    }

    .profile-statistics-payment-modal__container-table__header-col__tournament, .profile-statistics-payment-modal__container-table__body-tournament__col.data {
        width: 100%;
    }

    .profile-statistics-payment-modal__container-table__body-tournament__mobile-amount .primary-button {
        font-size: 14px;
        line-height: 16px;
        padding: 8px 20px;
    }

    .profile-statistics-payment-modal .modal2__header {
        border-bottom: 1px solid var(--new-background-color);
        padding-bottom: 12px;
    }

    .profile-statistics-payment-modal__unlock-all-action {
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .profile-statistics-payment-modal__unlock-all-action .primary-button {
        display: block;
        width: 100%;
    }
 }
`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-statistics-payment-modal/ProfileStatisticsPaymentModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,yDAAyD;IACzD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;CACf;;CAEA;IACG,gBAAgB;CACnB;;CAEA;IACG,oCAAoC;IACpC,kBAAkB;CACrB;;CAEA;IACG,aAAa;IACb,mBAAmB;IACnB,QAAQ;CACX;;CAEA;IACG,gCAAgC;IAChC,gBAAgB;IAChB,kDAAkD;IAClD,8CAA8C;IAC9C,mBAAmB;CACtB;;CAEA;IACG,iBAAiB;IACjB,eAAe;IACf,iBAAiB;CACpB;;CAEA;IACG,uDAAuD;IACvD,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,yBAAyB;CAC5B;;CAEA;;IAEG,eAAe;IACf,iBAAiB;CACpB;;CAEA;IACG,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;CAClB;;CAEA;IACG,eAAe;IACf,yDAAyD;CAC5D;;CAEA;IACG,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;CAEC,yCAAyC,4BAA4B;;IAElE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,oDAAoD;QACpD,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;CACH","sourcesContent":[".profile-statistics-payment-modal__container {\n    padding: 18px 36px;\n}\n\n.profile-statistics-payment-modal__container-text.baloa-table {\n    color: var(--primary-dark-color);\n    margin-bottom: 12px;\n}\n\n.profile-statistics-payment-modal__container-table {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n}\n\n.profile-statistics-payment-modal__container-table__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 24px;\n    background: var(--new-background-color);\n    border-radius: 7px;\n    margin-bottom: 10px;\n}\n\n.profile-statistics-payment-modal__container-table__header-col__tournament,\n.profile-statistics-payment-modal__container-table__body-tournament__col.data {\n    width: 50%;\n}\n\n.profile-statistics-payment-modal__container-table__header-col__value,\n.profile-statistics-payment-modal__container-table__body-tournament__col.value {\n    width: 25%;\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__col.value .baloa-names {\n    color: var(--primary-very-dark-color);\n    white-space: nowrap;\n}\n\n.profile-statistics-payment-modal__container-table__header-col__blank,\n.profile-statistics-payment-modal__container-table__body-tournament__col.action {\n    width: 25%;\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__col.action {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.profile-statistics-payment-modal__container-table__header .baloa-table-column {\n    color: var(--basic-gray-color);\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__container {\n    padding: 12px 24px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    display: flex;\n    align-items: center;\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__container:last-of-type {\n    border-bottom: none;\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__col.data {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__col-info__img img {\n    width: 39px;\n    height: 39px;\n    border-radius: 50%;\n}\n\n.profile-statistics-payment-modal__container-table__body-tournament__col-info__img .icon-ball {\n    color: var( --white-color );\n    font-size: 39px;\n    border-radius: 50%;\n    padding: 4px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament {\n    margin-left: 8px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament .baloa-names {\n    color: var(-primary-very-dark-color);\n    margin-bottom: 4px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament-labels {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__col-info__tournament-labels .baloa-mini {\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    background: var(--new-grey-light-background-color);\n    border: 1px solid var(--new-grey-border-color);\n    border-radius: 25px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__col.action .primary-button {\n    padding: 8px 20px;\n    font-size: 14px;\n    line-height: 16px;\n }\n\n .profile-statistics-payment-modal__unlock-all-action {\n    border-top: 1px solid var(--new-input-background-color);\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n }\n\n .profile-statistics-payment-modal__unlock-all-action .primary-button,\n .profile-statistics-payment-modal__container-table__body-tournament__mobile-amount .primary-button {\n    font-size: 16px;\n    line-height: 19px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__mobile-amount {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n }\n\n .profile-statistics-payment-modal__container-table__body-tournament__mobile-container {\n    padding: 16px 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n }\n\n .profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar {\n    display: none; \n}\n\n.profile-statistics-payment-modal__container-table__body .infinite-scroll-component:hover::-webkit-scrollbar {\n    display: initial;\n}\n\n.profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar:vertical {\n    width:10px;\n}\n\n.profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar:horizontal {\n    height: 10px;\n}\n\n.profile-statistics-payment-modal__container-table__body .infinite-scroll-component::-webkit-scrollbar-thumb {\n    background-color: #797979;\n    border-radius: 20px;\n    border: 2px solid #f1f2f3;\n}\n\n @media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .profile-statistics-payment-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: 100%;\n        height: 100%;\n    }  \n    \n    .profile-statistics-payment-modal .modal2__content {\n        height: 100%;\n    }\n\n    .profile-statistics-payment-modal__container {\n        padding: 12px;\n    }\n\n    .profile-statistics-payment-modal__container-table {\n        border: none\n    }\n\n    .profile-statistics-payment-modal__container-table__header-col__tournament, .profile-statistics-payment-modal__container-table__body-tournament__col.data {\n        width: 100%;\n    }\n\n    .profile-statistics-payment-modal__container-table__body-tournament__mobile-amount .primary-button {\n        font-size: 14px;\n        line-height: 16px;\n        padding: 8px 20px;\n    }\n\n    .profile-statistics-payment-modal .modal2__header {\n        border-bottom: 1px solid var(--new-background-color);\n        padding-bottom: 12px;\n    }\n\n    .profile-statistics-payment-modal__unlock-all-action {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .profile-statistics-payment-modal__unlock-all-action .primary-button {\n        display: block;\n        width: 100%;\n    }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
